export const OUT_OF_STOCK = 'Back in stock soon';
